import * as React from 'react';

import { useStore } from 'zustand';

import { ButtonModel, IconRegularChevronLeft } from '@notino/react-styleguide';

import { BackButton } from './PhotosGrid/styled';
import { PhotosStoreStore } from './store/createPhotosStore';

export const DrawerHeaderTitle = ({ store }: { store: PhotosStoreStore }) => {
  const {
    selectedPhoto,
    actions: { setSelectedPhoto },
  } = useStore(store);

  return (
    <BackButton
      buttonStyle={ButtonModel.Styles.secondary}
      onClick={() => setSelectedPhoto(undefined)}
      style={{ visibility: selectedPhoto ? 'visible' : 'hidden' }}
    >
      <IconRegularChevronLeft width="24px" height="24px" />
    </BackButton>
  );
};
